import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import withRouter from "components/Common/withRouter";

//i18n
import { withTranslation } from "react-i18next";
import SidebarProfile from "./SidebarProfile";
import SidebarContent from "./SidebarContent";
import { Link } from "react-router-dom";

import logo from "assets/images/logo.png";
import logoMini from "assets/images/logo-mini.png";

const Sidebar = (props) => {
  const styleLogo = {};

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="sidebar-nav mt-4">
          <Link to="/">
            <span className="mini-menu">
              <img src={logoMini} alt="F&N affiliate" style={{ width: "100%" }} />
            </span>
            <span className="full-menu">
              <img src={logo} alt="F&N affiliate" style={{ height: "32px" }} />
            </span>
          </Link>
        </div>
        <div>
          <span className="mini-menu">
            <SidebarProfile condensed={true} />
            <SidebarContent condensed={true} />
          </span>
          <span className="full-menu">
            <SidebarProfile condensed={false} />
            <SidebarContent condensed={false} />
          </span>
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = (state) => {
  return {
    layout: state.Layout,
  };
};
export default connect(mapStatetoProps, {})(withRouter(withTranslation()(Sidebar)));
